import React from "react";
import PricingPlans from "../../components/Plan Details/PricingPlans";
import PageHeader from "../../components/common/PageHeader";
import LatestServiceOffer from "../../components/common/LatestServiceOffer";

const ChooseYourPlan = () => {
  return (
    <div>
      <PageHeader title="Our Menu" />
      <PricingPlans />
      <LatestServiceOffer />
    </div>
  );
};

export default ChooseYourPlan;
